import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var GameTag;
(function(GameTag2) {
  GameTag2["HOT"] = "hot";
  GameTag2["NEW"] = "new";
  GameTag2["GAME_OF_THE_MONTH"] = "gotm";
  GameTag2["GAME_OF_THE_YEAR"] = "goty";
  GameTag2["RECOMMENDED"] = "recommended";
  GameTag2["EDITORS_CHOICE"] = "editors-choice";
  GameTag2["BET"] = "bet";
})(GameTag || (GameTag = {}));
let TagComponent = class extends Mixins(MagicConfigMixin) {
};
__decorateClass([
  Prop(String)
], TagComponent.prototype, "variant", 2);
TagComponent = __decorateClass([
  Component({
    name: "ui-tag"
  })
], TagComponent);

export default TagComponent;
export { GameTag };
